import api from "./interceptor";

export const create = (data, endpoint) => {
    // console.log(token)
    return api.post(endpoint, data);
  };
  export const get = ( endpoint) => {
    // console.log(token)
    return api.get(endpoint);
  };
  export const update = ( endpoint,data) => {
    // console.log(token)
    return api.put(endpoint,data);
  };
  export const deleteFrom = ( endpoint) => {
    // console.log(token)
    return api.delete(endpoint);
  };